/* eslint-disable max-len */
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExpandablePanelComponent } from '@sondermind/features/expandable-panel';
import { IFrequentlyAskedQuestion } from '../../models/frequently-asked-question.interface';

@Component({
  standalone: true,
  selector: 'faq-dropdown',
  templateUrl: './faq-dropdown.component.html',
  styleUrls: ['./faq-dropdown.component.scss'],
  imports: [CommonModule, ExpandablePanelComponent]
})

export class FAQDropdownComponent {
  frequentlyAskedQuestionList: IFrequentlyAskedQuestion[] = [
    {
      question: 'How much will my appointment cost with SonderMind?',
      answer: 'The exact cost depends on several factors including your location, the length of the session scheduled with your provider, and the type of care. We recommend calling your insurance company directly to determine what your out-of-pocket costs will be as this will vary based on your individual insurance plan. If you are not using insurance, please submit a request to the Support team via our <a href="https://www.sondermind.com/contact-us" target="_blank">Contact Us form</a> for more detailed information regarding the rates in your state.',
    },
    {
      question: 'Can I use my insurance to pay for care?',
      answer: 'Yes. SonderMind providers are in-network with most major insurance plans - including HSA, FSA, EAP, Medicare and Medicare Advantage plans. As SonderMind expands to new states, more insurance plans will be coming. We also offer affordable self-pay rates if you aren\'t using insurance. SonderMind providers are not currently in-network with Medicaid or Tricare. <br/> Call 844-THERAPY or visit <a href="https://www.sondermind.com/insurance" target="_blank">sondermind.com/insurance</a> for more information.',
    },
    {
      question: 'What should I expect at my first therapy appointment?',
      answer: 'The first therapy appointment is typically longer than follow-up appointments so your therapist can get to know more about you. You’ll cover things like your background and reasons for coming in, as well as what to expect and how your therapist will conduct sessions. We\'ve put together <a href="https://www.sondermind.com/resources/articles-and-content/your-first-therapy-session-faq/" target="_blank">a handy Q&A for your reference when preparing for your first therapy session</a>.',
    },
  ];
}
